/// <reference path="scopeEditorController.ts"/>

module ProcessEditor {
    "use strict";
    import ModalInstanceService = angular.ui.bootstrap.IModalServiceInstance;

    export class TriggersModalController {
        public process: Process;
        public static $inject = ["process", "$uibModalInstance", "$scope"];
        constructor(private processData: Process, private $modalInstance: ModalInstanceService, private $scope: IValidationScope) {
            // View is bound to a clone of the process.
            // Pressing OK sends the clone to the parent controller, and the original model is updated from it.
            // Pressing Cancel just discards the clone.
            this.process = angular.copy(processData);
        }

        public addTrigger() {
            var random = (Math.random() + 1).toString(36).substring(7);
            var trigger = new Trigger(
                {
                    $type: "HttpTrigger",
                    nodeId: "ProcessTrigger_"+random,
                    name: "",
                    config: { routeTemplate: "" }
                });
            this.process.triggers.push(trigger);

            // Activate the new trigger
            _.each(this.process.triggers,(t: Trigger) => {
                t.selectedTab = (t.nodeId === trigger.nodeId);
            });

            // clear errors from being shown, so they are not shown in the new tab
            this.$scope.showValidationErrors = false;
        }

        public removeTrigger(e, trigger: Trigger, triggersForm:ng.IFormController) {
            e.preventDefault();
            var indexOfTrigger = this.process.triggers.indexOf(trigger);
            this.process.triggers.splice(indexOfTrigger, 1);
            triggersForm.$setDirty();
        }

        public isFormInvalid(form) {
            return form.$invalid && this.$scope.showValidationErrors;
        }

        public close(form: ng.IFormController) {
            if (form.$invalid) {
                // errors -> show by setting the magic constant in the scope
                this.$scope.showValidationErrors = true;
                return false;
            }

            this.$modalInstance.close(new TriggersModalResult(this.process, form.$dirty));
        }

        public cancel() {
            this.$modalInstance.dismiss();
        }
    }
    app.controller("TriggersModalController", TriggersModalController);
    
    export class TriggersModalResult {
        constructor( public updatedProcess: Process, public changesMade: Boolean) {}
    }

    export function uniqueTriggerNameValidatorDirective($rootScope): ng.IDirective {
        return {
            restrict: "A",
            require: "ngModel",
            link: (scope: TriggersModalScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
                var doValidation = () => {
                    var allTriggers = _.filter(scope.triggersModalCtrl.process.triggers, (trigger: Trigger) => {
                        return trigger.name && scope.trigger.nodeId !== trigger.nodeId;
                    });
                    var blacklist = _.map(allTriggers, (trigger) => {
                        return trigger.name.toLowerCase();
                    });

                    var valid = blacklist.indexOf(element.val().toLowerCase()) === -1;
                    ngModel.$setValidity("unique", valid);
                };

                element.bind("keyup",() => {
                    scope.$apply(() => {
                        $rootScope.$broadcast("validatetriggername");
                    });
                });
                scope.$on("validatetriggername", doValidation);
            }
        }
    }
    app.directive("uniqueTriggerNameValidator", ["$rootScope", uniqueTriggerNameValidatorDirective]);

    interface TriggersModalScope extends ng.IScope{
        triggersModalCtrl: TriggersModalController;
        trigger: Trigger;
    }
}

